// extracted by mini-css-extract-plugin
export default {"mask":"index_mask_MhZfn","video_wp":"index_video_wp_LrNa2","close":"index_close_micVX"};